import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_first",
  "use": "icon-icon_first-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-icon_first\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M28.94 33.667a1.5 1.5 0 0 0 2.12-2.121L21.516 22l9.546-9.546a1.5 1.5 0 0 0-2.122-2.121L18.333 20.939a1.5 1.5 0 0 0-.098 2.015l.098.107 10.606 10.606Z\" /><rect transform=\"matrix(-1 0 0 1 27 0)\" x=\"12\" y=\"10\" width=\"3\" height=\"24\" rx=\"1.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol